import styled from "@emotion/styled"
import { css } from '@emotion/react'
import facepaint from "facepaint"

import { Link as GatsbyLink } from "gatsby"

import Button from 'components/forms/button/Button'

const breakpoints = [768, 1024, 1280]
const mq = facepaint(breakpoints.map(bp => `@media (min-width: ${bp}px)`))

const contentBordered = ({ isBordered }) => {
  if (isBordered) {
    return css(mq({
      outline: "1px solid var(--color-grayscale-50)",
      boxShadow: [
        "none", // 0+
        "none", // 440+
        "none", // 768+
        "var(--elevation-light-panel)",
      ],
    }))
  }
}

export const Wrap = styled.header`
  display: flex;
  position: sticky;
  width: 100vw;
  top: 0;
  z-index: 11;
`

export const BluredBackdrop = styled.div`
  position: absolute;
  inset: 0;
  z-index: 1;
  pointer-events: none;
  backdrop-filter: blur(5px);
  mask-image: linear-gradient(to bottom, #fff 20%, transparent calc(100% - 20%));
`

const contentMQ = css(mq({
  padding: [
    "20px 16px 20px 20px", // 0+
    "20px 16px 20px 20px", // 440+
    "20px 16px 20px 20px", // 768+
    "12px 20px", // 1024+
  ],
  margin: [
    0, // 0+
    0, // 440+
    0, // 768+
    "16px auto auto", // 1024+
  ],
  borderRadius: [
    0, // 0+
    0, // 440+
    0, // 768+
    16, // 1024+
  ],
  height: [
    80, // 0+
    80, // 440+
    80, // 768+
    "auto", // 1024+
    "auto", // 1200+
    "auto", // 1400+
  ],
  width: [
    "100vw", // 0+
    "100vw", // 440+
    "100vw", // 768+
    1520, // 1024+
  ],
  maxWidth: [
    "100vw", // 0+
    "100vw", // 440+
    "100vw", // 768+
    "calc(100vw - 32px)", // 1024+
  ],
}))

export const Content = styled.div`
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: space-between;
  outline: 1px solid transparent;
  background: var(--color-white);
  transition: box-shadow var(--transition), outline var(--transition);
  ${contentBordered}
  ${contentMQ}
`

export const LogoMenuSection = styled.div`
  position: relative;
  display: flex;
  flex-shrink: 0;
  align-items: center;
  gap: 24px;
`

export const LogoLink = styled(GatsbyLink)`
  padding: 4px 0;
`

export const Logo = styled.img`
  display: block;
`

const mainMenuMQ = css(mq({
  display: [
    "none",
    "flex",
    "flex",
    "flex",
  ],
}))

export const MainMenu = styled.div`
  display: flex;
  gap: 8px;
  ${mainMenuMQ}
`

const signInUpSectionMQ = css(mq({
  display: [
    "none",
    "flex",
    "flex",
    "flex",
  ],
}))

export const SignInUpSection = styled.div`
  align-items: center;
  gap: 12px;
  ${signInUpSectionMQ}
`

const mobileMenuButtonMQ = css(mq({
  display: [
    "flex",
    "none",
    "none",
    "none",
  ],
}))

export const MobileMenuButton = styled(Button)`
  & svg {
    stroke-width: 1.5px;
  }
  ${mobileMenuButtonMQ}
`
